<template>
    <div class="table">
        <div class="container">
            <div class="app-container">
                <div style="margin-bottom: 20px;margin-top: 20px">
                    <el-input v-model="listQuery.name" placeholder="类型名称" style="width:200px;"></el-input>
                    <el-button
                            class="filter-item"
                            style="margin-left: 10px;"
                            type="primary"
                            icon="el-icon-search"
                            @click="handleFilter"
                    >搜索</el-button>
                    <el-button
                            class="filter-item"
                            style="margin-left: 10px;"
                            type="success"
                            
                            @click="handleCreate"
                    >添加</el-button>

                </div>

                <el-table border v-loading="listLoading"  min-height="200"  max-height="1000" :data="tableData" style="width: 100%">
                    <el-table-column prop="id" label="ID"/>
                    <el-table-column prop="name" label="类型名称" />
                    <el-table-column label="操作"  width="260" class-name="small-padding fixed-width">
                        <template slot-scope="scope">
                            <el-button
                                    type="primary"
                                    icon="el-icon-edit"
                                    style="margin-right: 10px;"
                                    size="mini"
                                    @click="handleUpdate(scope.row)"
                            >修改</el-button>
                            <el-popover placement="top" width="160" v-model="scope.row.deleteVisible">
                                <p>确定删除吗?</p>
                                <div style="text-align: right; margin: 0">
                                    <el-button size="mini" type="text" @click="scope.row.deleteVisible = false">取消</el-button>
                                    <el-button type="primary" size="mini" @click="handleDelete(scope.row)">确定</el-button>
                                </div>
                                <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete">删除</el-button>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>

                <pagination
                        v-show="total>0"
                        :total="total"
                        :page.sync="listQuery.page"
                        :limit.sync="listQuery.limit"
                        @pagination="handleList"
                />
                <el-dialog :title="popupTitle" width="60%" :visible.sync="dialogFormVisible" center  @close='closeDialog' :close-on-click-modal= addControl>
                    <el-form :model="formData" style="margin-left:50px;">
                        <el-form-item label="ID" :label-width="formLabelWidth" v-if="formData.id != ''">
                            <el-col :span="8">
                                <el-input v-model="formData.id" :disabled="idDisabled"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="问题类型" :label-width="formLabelWidth">
                            <el-col :span="8">
                                <el-input v-model="formData.name"></el-input>
                            </el-col>
                        </el-form-item>

                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="removeForm">取 消</el-button>
                        <el-button type="primary" @click="handleCreateUpdateStore">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        handleListApi,
        handleCreateStoreApi,
        handleDeleteApi
    } from "@/api/faq_type.js";
    import Pagination from "@/components/pagination/index";
    export default {
        components: { Pagination },
        data() {
            return {
                // 列表
                listLoading: false,
                total: 0,
                tableData: [],
                listQuery: {
                    page: 1,
                    limit: 10,
                    work_sn:undefined
                },
                // 添加数据的缓存。
                addData:{},
                addCheck:0,
                popupTitle:"",
                // 表单
                dialogFormVisible: false,
                idDisabled: true,
                formData: {
                    id: "",
                    account: "",
                    title: "",
                    type: "",
                    name: ""
                },
                formLabelWidth: "120px",
            };
        },
        created() {
            this.handleList(this.listQuery);
        },
        computed:{
            addControl(){
            let item = true;
            if(this.popupTitle  == "添加"){
                item = false;
            }
            return item;
            }
        },
        methods: {
            handleList() {
                this.listLoading = true;
                handleListApi(this.listQuery)
                    .then(response => {
                        const data = response.data.data;
                        this.tableData = data;
                        this.total = response.data.total;
                        setTimeout(() => {
                            this.listLoading = false;
                        }, 0.5 * 1000);
                    })
                    .catch(error => {
                        this.listLoading = false;
                    });
            },
            handleCreate() {
                this.handleResetForm();
                this.popupTitle = "添加";
                 if(this.addCheck == 1){
                    this.formData = JSON.parse(JSON.stringify(this.addData));
                 }
                this.dialogFormVisible = true;
            },
             closeDialog(){
                if(this.popupTitle  == "添加" && (this.addCheck == 0 || this.addCheck == 1)){
                this.addData = JSON.parse(JSON.stringify(this.formData));
                    this.addCheck = 1;
                }
                if(this.popupTitle  == "添加" && this.addCheck == 2){
                    this.addCheck = 0;
                    this.addData = {};
                }
            },
            handleUpdate(row) {
                this.popupTitle = "修改";
                this.dialogFormVisible = true;
                this.formData.id = row.id;
                this.formData.name = row.name;
                handleListApi({'id':row.id})
                    .then(response => {
                        const data = response.data.data;
                        this.tableData = data;
                    })
                    .catch(error => {
                    });
            },
            handleDelete(row) {
                handleDeleteApi(row)
                    .then(response => {
                        var showType = 1 == response.data.code ? 'success' : 'error';
                        this.$message({
                            message: response.data.message,
                            type: showType
                        });
                        row.deleteVisible = false;
                        this.handleList(this.listQuery);
                    })
                    .catch(error => {
                    });
            },
            handleResetForm() {
                this.formData.id = "";
                this.formData.name = "";
                this.dialogFormVisible = false;
            },
            removeForm(){
                this.dialogFormVisible = false;
            },
            handleCreateUpdateStore() {
                handleCreateStoreApi(this.formData)
                    .then(response => {
                        if (response.data.code == 1){
                            this.$message.success("操作成功");
                             if(this.formData.id == ""){
                                this.addCheck = 2;
                            }
                            this.dialogFormVisible = false;
                            this.handleList(this.listQuery);
                        }else{
                            this.$message.error(response.data.message);
                        }
                    })
                    .catch(error => {});
            },
            handleFilter() {
                this.listQuery.page = 1;
                this.handleList(this.listQuery);
            },
        }
    };
</script>
<style >
    div.el-transfer .el-transfer-panel {
        width: 400px;
    }
</style>
